module.exports = __webpack_public_path__ + "img/tank-base-2.e8f3d9a5.png";